import { Control, FieldValues } from 'react-hook-form';

import { InputCollection } from './InputCollection';
import { InformationType, infoTypeMap } from '../data';
interface IAdditionalInfoRelated {
  currentSelection: InformationType;
  control: Control<FieldValues, any>;
  index: number;
  onRemoveLast?: () => void;
}
const AdditionalInfoRelated = ({
  currentSelection,
  control,
  index,
  onRemoveLast,
}: IAdditionalInfoRelated) => {
  const currentInfotype =
    infoTypeMap[currentSelection as keyof typeof infoTypeMap];
  return (
    currentSelection &&
    currentInfotype && (
      <InputCollection
        control={control}
        {...currentInfotype}
        name={`informationType.${index}.items`}
        populateByDefault={true}
        onRemoveLast={onRemoveLast}
      />
    )
  );
};
export default AdditionalInfoRelated;
